import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import { DefaultButton } from "@fluentui/react/lib/Button";
import * as React from "react";
import { styles } from "./FTL.styles";

function staleRatesMessage(quotedAt: string | undefined, hasRates: boolean): string | null {
  if (!quotedAt || !hasRates) return null;
  const quotedDate = new Date(quotedAt);
  const today = new Date();
  const isStale =
    quotedDate.getFullYear() !== today.getFullYear() ||
    quotedDate.getMonth() !== today.getMonth() ||
    quotedDate.getDate() !== today.getDate();

  if (!isStale) return null;
  const label = quotedDate.toLocaleDateString(undefined, {
    month: "long",
    day: "numeric",
    year: "numeric",
  });

  return `Offer is from ${label}. May need to refresh rates!`;
}

export function FtlPricingActions({
  onViewOffers,
  onNext,
  onReset,
  onClear,
  isFormValid,
  hasSelectedOffer,
  quotedAt,
  hasExistingRates,
}: {
  onViewOffers: () => void;
  onNext: (e: React.MouseEvent<HTMLElement>) => void;
  onReset: () => void;
  onClear: () => void;
  isFormValid: boolean;
  hasSelectedOffer: boolean;
  quotedAt?: string;
  hasExistingRates?: boolean;
}): React.ReactElement {
  const staleLabel = staleRatesMessage(quotedAt, !!hasExistingRates);

  return (
    <Box sx={styles.actionsContainer}>
      <DefaultButton
        text="View Offers"
        type="button"
        onClick={onViewOffers}
        allowDisabledFocus
        styles={styles.primaryButton}
        disabled={!isFormValid}
      />
      {staleLabel && (
        <div style={{ fontSize: "11px", color: "#d32f2f", marginTop: "4px" }}>{staleLabel}</div>
      )}
      <Stack direction="row" sx={styles.secondaryActions} useFlexGap flexWrap="wrap">
        <DefaultButton
          text="Next"
          type="button"
          title="Select an offer"
          onClick={onNext}
          styles={styles.secondaryButton}
          disabled={!hasSelectedOffer}
        />
        <DefaultButton
          text="Reset"
          type="button"
          title="Restore shipment to original state and save to server"
          onClick={onReset}
          allowDisabledFocus
          styles={styles.tertiaryButton}
        />
        <DefaultButton
          text="Clear"
          type="button"
          title="Clear all inputs (does not save)"
          onClick={onClear}
          allowDisabledFocus
          styles={styles.tertiaryButton}
        />
      </Stack>
    </Box>
  );
}
